export const css = {
	root: 'xh_AHqS1',
	heading: '_2cltzyKC',
	' _key': 'apic-theme/apic/micro/base-widgets/accordion2'
};

export default css;
